module.exports = __webpack_public_path__ + "spine/building_celebration_3x6.json?c76bd3bdc47a1cad655a29baec7894e9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spine/building_construction/building_celebration_3x6.json
// module id = 1753
// module chunks = 3